import { useMemo } from "react";
import { RefreshIcon } from "../components/Icons.jsx";
import "../styles/user-management.css";

export default function UserManagementPage({
  currentUser,
  userState,
  userFilter,
  userForm,
  userFormState,
  onUserFilterChange,
  onUserRefresh,
  onUserFormChange,
  onUserCreate,
}) {
  const visibleUsers = useMemo(() => userState.users || [], [userState.users]);

  return (
    <main className="cg-page-shell">
      <div className="cg-page-frame">
        <section className="cg-panel cg-page-card cg-user-page-panel">
          <div className="cg-panel-header">
            <div>
              <span className="cg-kicker">User Management</span>
              <h2>Team access</h2>
              <p className="cg-muted-text">
                Manage approved users and create new accounts for the Cologuard workspace.
              </p>
            </div>
            <button type="button" className="cg-page-refresh-button" onClick={onUserRefresh}>
              <RefreshIcon />
              Refresh data
            </button>
          </div>

          <div className="cg-user-layout">
            <section className="cg-user-section">
              <div className="cg-user-section-heading">
                <div>
                  <span className="cg-kicker">Directory</span>
                  <h2>Current users</h2>
                </div>
              </div>

              <div className="cg-user-toolbar">
                <input
                  type="text"
                  value={userFilter}
                  onChange={(event) => onUserFilterChange(event.target.value)}
                  placeholder="Filter by email or name"
                />
              </div>

              {userState.error ? <p className="cg-error-text">{userState.error}</p> : null}

              <div className="cg-history-table-wrap">
                <table className="cg-history-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userState.loading ? (
                      <tr>
                        <td colSpan="5">Loading users...</td>
                      </tr>
                    ) : visibleUsers.length ? (
                      visibleUsers.map((user) => (
                        <tr key={user.user_id || user.email}>
                          <td>{user.name || "N/A"}</td>
                          <td>{user.email || "N/A"}</td>
                          <td>{user.role || "N/A"}</td>
                          <td>{user.status || "N/A"}</td>
                          <td>{user.active ? "Yes" : "No"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5">No users found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </section>

            <section className="cg-user-section cg-user-create-section">
              <div>
                <div>
                  <span className="cg-kicker">Create User</span>
                  <h2>Add a teammate</h2>
                </div>
              </div>

              <form className="cg-campaign-form" onSubmit={onUserCreate}>
                <label>
                  Full name
                  <input
                    name="name"
                    type="text"
                    value={userForm.name}
                    onChange={onUserFormChange}
                    placeholder="Team member name"
                  />
                </label>

                <label>
                  Email
                  <input
                    name="email"
                    type="email"
                    value={userForm.email}
                    onChange={onUserFormChange}
                    placeholder="user@example.com"
                  />
                </label>

                <label>
                  Role
                  <select name="role" value={userForm.role} onChange={onUserFormChange}>
                    <option value="viewer">Viewer</option>
                    <option value="manager">Manager</option>
                    <option value="admin">Admin</option>
                  </select>
                </label>

                <p className="cg-muted-text">
                  The teammate will receive an email with instructions to finish setting
                  up their account.
                </p>

                {userFormState.error ? <p className="cg-error-text">{userFormState.error}</p> : null}
                {userFormState.success ? (
                  <p className="cg-success-text">{userFormState.success}</p>
                ) : null}

                <button type="submit" disabled={userFormState.submitting || !currentUser?.user_id}>
                  {userFormState.submitting ? "Creating..." : "Create User"}
                </button>
              </form>
            </section>
          </div>
        </section>
      </div>
    </main>
  );
}
